import { createSelector } from 'reselect'
import * as SelectorUtils from './utils'

import { DefaultState } from '../reducers/DefaultState'

const getSubscriberId = (state, props) => {
  let subscriberId = null
  if (props.shortcut && props.shortcut.target_id) {
    subscriberId = props.shortcut.target_id
  } else {
    subscriberId = props.match.params.subscriberId
  }
  return subscriberId
}

const getSubscriberState = (state) => {
  return (state || {}).subscriber || null
}

const getSelectedMetricDate = createSelector(
  [getSubscriberState],
  (state) => {
    return (state || {}).selectedMetricDate || null
  }
)

const getSelectedSubscriberNetwork = (state) => {
  return state.subscriber.selectedNetwork
}

const getCatalogOverviewDetails = createSelector(
  [getSubscriberState, getSelectedMetricDate],
  (catalogOverviewState, metricDate) => {
    return catalogOverviewState ? catalogOverviewState.byMetricDate[metricDate] : null
  }
)

const getCatalogOverviewDetailsState = createSelector(
  [getCatalogOverviewDetails],
  (state) => {
    return (state || {}).overview || DefaultState
  }
)

const getCatalogGenreTitleDetailsState = createSelector(
  [getCatalogOverviewDetails],
  (state) => {
    return (state || {}).genreTitle || DefaultState
  }
)

const getSubscriberWhatsNewState = createSelector(
  [getSubscriberState, getSelectedSubscriberNetwork],
  (subscriberState, selectedSubscriberNetwork) => {
    if (selectedSubscriberNetwork) {
      return (subscriberState.byNetwork[selectedSubscriberNetwork] || {}).whatsNew || DefaultState
    }
    return DefaultState
  }
)

const makeCatalogOverviewDetailsSelector = () => {
  return createSelector(
    [getCatalogOverviewDetailsState],
    (details) => {
      if (details) {
        return {
          isFetching: SelectorUtils.isFetching(details),
          error: details.error,
          details: details.details
        }
      }
    }
  )
}

const makeCatalogGenreTitleDetailsSelector = () => {
  return createSelector(
    [getCatalogGenreTitleDetailsState],
    (details) => {
      if (details) {
        return {
          isFetching: SelectorUtils.isFetching(details),
          error: details.error,
          details: details.details
        }
      }
    }
  )
}

const makeSubscriberIdSelector = () => {
  return createSelector(
    [getSubscriberId],
    subscriberId => {
      return subscriberId
    }
  )
}

const makeSubscriberWhatsNewSelector = () => {
  return createSelector(
    [getSubscriberWhatsNewState],
    (details) => {
      return {
        isFetching: SelectorUtils.isFetching(details),
        error: details.error,
        details: details.details
      }
    }
  )
}

export {
  makeSubscriberIdSelector,
  makeCatalogOverviewDetailsSelector,
  makeCatalogGenreTitleDetailsSelector,
  makeSubscriberWhatsNewSelector
}
